import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { mixpanel, scrollToElement, constants } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedHTMLMessage } from 'sb-react-intl'
import injectGlobals from 'decorators/injectGlobals'

import Modal from 'components/modal/Modal/Modal'
import Button from 'components/buttons/Button/Button'

import messages from './messages'
import s from './PrepaidCardWithDiscountModal.scss'


class PrepaidCardWithDiscountModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      authCode: PropTypes.string,
    }),
    isProceedWithPrepaidCardEnabled: PropTypes.bool, // @injectGlobals
  }

  static defaultProps = {
    name: constants.modals.prepaidCard.PrepaidCardWithDiscount,
  }

  state = {
    isWaiting: false,
  }

  componentDidMount() {
    const { data: { authCode } } = this.props

    mixpanel.track(constants.analyticsEvents.cardFailed[authCode])
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  applyCoupon = () => {
    const couponCode = 'CARDFAILED'

    this.setState({ isWaiting: true })

    actions.view.paymentPage.fetchDiscount({ code: couponCode })
      .then(() => actions.view.paymentPage.inquireSubscription({}))
      .then(() => {
        this.close()
        // Scroll to credit card form
        scrollToElement('creditCardForm', true)
        // Clear credit card form fields
        actions.view.paymentPage.changeEventForCleanCreditCardForm(true)
      })
      .finally(() => this.setState({ isWaiting: false }))
  }

  render() {
    const { isWaiting } = this.state
    const { name, data: { authCode, handleProceed }, isProceedWithPrepaidCardEnabled } = this.props
    const isPrepaidCard = parseInt(authCode, 10) === 309 || parseInt(authCode, 10) === 409
    const isNotEnougth = parseInt(authCode, 10) === 101

    let titleMessage = messages.title
    let buttonMessage = messages.orderButton
    let textMessage

    if (isPrepaidCard) {
      titleMessage = messages.titlePrepaid
      buttonMessage = messages.orderButtonPrepaid
      textMessage = messages.textPrepaid
    }

    if (isNotEnougth) {
      textMessage = messages.textNotEnougth
    }

    return (
      <Modal
        className={s.prepaidCardWithDiscountModal}
        name={name}
        title={titleMessage}
        onClose={this.close}
      >
        {
          textMessage && (
            <FormattedHTMLMessage className={s.text} tag="div" {...textMessage} />
          )
        }
        <FormattedHTMLMessage className={s.note} tag="div" {...messages.note} />
        <Button
          className={s.button}
          brand
          md
          loading={isWaiting}
          title={buttonMessage}
          onClick={this.applyCoupon}
        />
        {
          (isProceedWithPrepaidCardEnabled && isPrepaidCard && handleProceed) && (
            <Button
              className={s.button}
              whiteBrand
              md
              loading={isWaiting}
              title={messages.proceedButton}
              onClick={() => {
                this.close()
                actions.models.ui.showRequestLoader()

                handleProceed()
                  .finally(() => actions.models.ui.hideRequestLoader())
              }}
            />
          )
        }
      </Modal>
    )
  }
}


export default injectGlobals(({ getFeatureToggle }) => ({
  isProceedWithPrepaidCardEnabled: getFeatureToggle(constants.features.proceedWithPrepaidCard),
}))(PrepaidCardWithDiscountModal)
